import { createContext, Dispatch, SetStateAction } from 'react';

type TncApprovalState = {
  isApproved: boolean;
  setIsApproved: Dispatch<SetStateAction<boolean>>;
};

export const TncApprovalContext = createContext<TncApprovalState | null>(null);
